import { render, staticRenderFns } from "./regions.vue?vue&type=template&id=1cda4fe6&scoped=true"
import script from "./regions.vue?vue&type=script&lang=js"
export * from "./regions.vue?vue&type=script&lang=js"
import style0 from "./regions.vue?vue&type=style&index=0&id=1cda4fe6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cda4fe6",
  null
  
)

export default component.exports